module.exports = __webpack_public_path__ + "assets/img/how-to-play-img-4.01a7de7f.jpg";